export enum EnumLanguageCode {
  /** 简体中文 */
  zh_CN = 'zh_CN',
  /** 中文繁体 */
  zh_TW = 'zh_TW',
  /** 英文 */
  en_US = 'en_US'
}
export enum EnumLanguageClient {
  /** 小程序 */
  app = 'app',
  /** 管理端 */
  admin = 'admin',
  /** H5 */
  h5 = 'h5',
  /** PC */
  pc = 'pc'
}
